module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide"
  }, [_c('Row', _vm._l((_vm.dataInfo), function(list, index) {
    return _c('div', {
      key: index
    }, [_c('i-col', {
      attrs: {
        "span": _vm.col
      }
    }, [_c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(index + 1) + "、" + _vm._s(list.title))]), _vm._v(" "), _vm._l((list.data), function(item, index) {
      return _c('div', {
        key: index
      }, [_c('p', {
        staticClass: "title sub-title"
      }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _vm._l((item.info), function(info, index) {
        return _c('div', {
          key: index
        }, [_c('p', {
          staticClass: "label"
        }, [_vm._v(_vm._s(info))])])
      })], 2)
    })], 2)], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268cfed2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iGuide/iGuide.vue
// module id = 781
// module chunks = 10